var swiperGiveawaysThumbnails = new Swiper(".swiperGiveawaysThumbnails", {
  spaceBetween: 10,
  slidesPerView: 6,
  breakpoints: {
    320: {
        slidesPerView: 4.15,
        spaceBetween: 5,
    },
    750: {
        slidesPerView: 4.15,
        spaceBetween: 5,
    }
  },
  // freeMode: true,
  // watchSlidesProgress: true,
});

var swiper = new Swiper(".giveaway__container", {
    // autoplay: {
    //   delay: 3500,
    //   disableOnInteraction: true,
    // },
  slidesPerView: 3,
  spaceBetween: 25,
  navigation: {
    nextEl: ".giveaways__button-next",
    prevEl: ".giveaways__button-prev",
  },
  // pagination: {
  //   el: ".prize__pagination",
  //   clickable: true,
  // },
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    750: {
        slidesPerView: 3,
        spaceBetween: 25,
    }
  },
      thumbs: {
        swiper: swiperGiveawaysThumbnails,
      },
});
